<div class="row">
    <div class="col-sm-6 ">
        <div class="h-grid">
            <mat-card class="card">
                <mat-card class="card-header">
                    <div class="card-header-content d-flex">
                        <span class="tab-icon"><img [src]="cvaUI_url + '/assets/icons/notes-primary.svg'"
                                alt="transcript records" /></span>
                        <span class="tab-title">Transcript Records </span>
                    </div>
                </mat-card>
                <mat-card-content>
                    <div class="main-content">
                        <cva-record-transcription [hideLeftSection]="true" [isTabActive]="false" [isViewMode]="true" [transcription]="recordedTranscription"
                            (switchToEditMode)="switchToEditMode()"></cva-record-transcription>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="col-sm-6 ">
        <div class="h-grid">
            <mat-card class="card">
                <mat-card class="card-header">
                    <div class="card-header-content d-flex">
                        <span class="tab-icon"><img [src]="cvaUI_url + '/assets/icons/soap-notes-primary.svg'"
                                alt="soap-notes" /></span>
                        <span class="tab-title">SOAP Notes</span>
                    </div>
                </mat-card>
                <mat-card-content class="notes">
                    <div class="main-content">
                        <cva-soap-notes [appointment]="appointment" [isTabActive]="true" [isViewMode]="true"></cva-soap-notes>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>